import { ChangeEvent, useEffect, useState } from "react";
import { Form, Input, Select, AutoComplete, Checkbox } from "antd";
import Bin from "../../assets/bin.png";
import Refresh from "../../assets/refresh.png";
import "./NewParticipant.scss";
import { EditOutlined } from "@ant-design/icons";
import { phoneRegex, validatePersonalId } from "../../core/Utility";
import { AccommodationDto } from "../../models/Accommodation";
import { ParticipantPropDTO } from "../../models/Participant";
import { deleteRegistration } from "../../services/RegistrationService";
import { changeOneImportedParticipant } from "../../services/ImportedParticipantService";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const NewParticipant = (props: ParticipantPropDTO | any) => {
  const [phoneError, setPhoneError] = useState(false);

  let values = props.form.getFieldValue("additionalPerson");

  const [country, setCountry] = useState("Srbija");
  const data = props.form.getFieldsValue();

  useEffect(() => {
    if (props.paramsId && data.accommodations) {
      data?.accommodations.map((el: any, index: any) => {
        if (index === props.accommodationName) {
          el.additionalPerson.map((el1: any, index1: number) => {
            if (index1 === props.name) {
              if (el1?.country) {
                setCountry(el1.country);
              }
            }
          });
        }
      });
    }
    if (props.paramsId && data.additionalPerson) {
      data.additionalPerson?.map((data: any, index2: number) => {
        if (index2 === props.name) {
          if (data?.country) {
            setCountry(data.country);
          }
        }
      });
    }
    if (data.accommodations) {
      data?.accommodations.map((el: any, index: any) => {
        if (index === props.accommodationName) {
          el.additionalPerson.map((el1: any, index1: number) => {
            if (index1 === props.name) {
              if (el1?.country) {
                setCountry(el1.country);
              }
            }
          });
        }
      });
    }
    if (data.additionalPerson) {
      data.additionalPerson?.map((data: any, index2: number) => {
        if (index2 === props.name) {
          if (data?.country) {
            setCountry(data.country);
          }
        }
      });
    }
  }, [data.accommodations, data.additionalPerson]);

  useEffect(() => {
    let price = 0;
    if (
      !props.isAccommodationRequired ||
      props.isAccommodationRequired === undefined
    ) {
      if (typeof props.handleTotalPrice === "function") {
        console.log("values", values);
        values.map((el: any) => {
          price = price + props?.event?.registrationFee;
        });
        props.handleTotalPrice(price);
      }
    }
  }, [values, props.isAccommodationRequired]);

  const documentType = [
    { label: "Predavač", value: "Predavač" },
    { label: "Učesnik", value: "Učesnik" },
    { label: "Gost", value: "Gost" },
    { label: "VIP", value: "VIP" },
    { label: "Sponzorisan", value: "Sponzorisan" },
  ];

  const Country = [
    { label: "Srbija", value: "Srbija" },
    { label: "Inostranstvo", value: "Inostranstvo" },
  ];

  useEffect(() => {
    if (props.individual && props.name === 0) {
      setCountry(data.country ?? "Srbija");
    }
  }, [data]);

  useEffect(() => {
    if (!props.accommodation) {
      props.handleSpinner(false);
    }
  }, []);

  const handleCountryChange = (e: any) => {
    setCountry(e);
  };

  const onNameSelect = (value: any) => {
    const selectedImportParticipant = props.allImportedParticipants.find(
      (item: any) => `${item.firstName} ${item.lastName}` === value
    );

    if (props.accommodation) {
      const allAccommodations = props.form.getFieldValue("accommodations");
      const allAccommodationsNewData = allAccommodations.map(
        (el: any, index: number) => {
          if (index === props.accommodationName) {
            let temporaryData = { ...el };
            temporaryData.additionalPerson = temporaryData.additionalPerson.map(
              (el1: any, index1: number) => {
                if (index1 === props.name) {
                  return { ...el1, ...selectedImportParticipant };
                } else {
                  return el1;
                }
              }
            );
            return temporaryData;
          } else {
            return el;
          }
        }
      );

      props.form.setFieldValue("accommodations", allAccommodationsNewData);
    } else {
      const allParticipants = props.form.getFieldValue("additionalPerson");
      const allParticipantsNewData = allParticipants.map(
        (el2: any, index2: number) => {
          if (index2 === props.name) {
            return selectedImportParticipant;
          } else {
            return el2;
          }
        }
      );
      props.form.setFieldValue("additionalPerson", allParticipantsNewData);
    }

    return changeOneImportedParticipant(selectedImportParticipant.id)
      .then((response: any) => {
        return props.handleImportedParticipants();
      })
      .catch((err: any) => console.log(err));
  };

  const handleDeleteRow = () => {
    let values = props.form.getFieldValue("additionalPerson");
    if (!values) return;
    if (props.paramsId) {
      values = values.map((item: any, index: number) => {
        if (index === props.name) {
          deleteRegistration(item.id)
            .then((response: any) => {
              props.remove(props.name);
              props.handleGetPriceData(true);
            })
            .catch((err: Error) => console.log(err));
        }
      });
    } else {
      props.remove(props.name);
      props.handleGetPriceData(true);
    }
  };

  const handleResetFields = () => {
    let values = props.form.getFieldValue("accommodations");
    props.handleGetPriceData(true);
    values = values.map((item: AccommodationDto, index: number) => {
      if (index === props.accommodationName) {
        const particioants = item?.additionalPerson?.map(
          (participantItem: any, index: number) => {
            if (index === props.name) {
              participantItem = undefined;
            } else {
              return participantItem;
            }
          }
        );
        return (item = { ...item, additionalPerson: particioants });
      } else {
        return item;
      }
    });

    props.form.setFieldValue("accommodations", values);
  };

  // const handleDinnerCalculation = (e: ChangeEvent<HTMLInputElement>) => {
  //   if (!props.isAccommodationRequired) {
  //     if (e.target.checked) {
  //       props.handleTotalPrice(props.totalPrice + props?.event?.dinnerFee);
  //     } else {
  //       props.handleTotalPrice(props.totalPrice - props?.event?.dinnerFee);
  //     }
  //   }
  // };

  // const handleRegistrationFeeCalculation = (
  //   e: ChangeEvent<HTMLInputElement>
  // ) => {
  //   if (!props.isAccommodationRequired) {
  //     if (e.target.checked) {
  //       props.handleTotalPrice(
  //         props.totalPrice + props?.event?.registrationFee
  //       );
  //     } else {
  //       props.handleTotalPrice(
  //         props.totalPrice - props?.event?.registrationFee
  //       );
  //     }
  //   }
  // };

  return (
    <div className="new-participants">
      <div className="inner-container-participant">
        <div className="header">
          <p className="participant-number">{`Učesnik - ${props.name + 1}`}</p>
        </div>
        {/* <Form.Item
          name={[props.name, "type"]}
          label="Tip učesnika:"
          rules={
            props.individual && props.name === 0
              ? []
              : [
                  {
                    required: true,
                    message: "Izaberite tip učesnika!",
                  },
                ]
          }
        >
          <Select
            onChange={() => props.handleGetPriceData(true)}
            placeholder="Tip učesnika"
            options={documentType}
          />
        </Form.Item> */}
        <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "firstName"]}
          label="Ime:"
          rules={
            props.individual && props.name === 0
              ? []
              : [
                  {
                    required: true,
                    message: "Potrebno je uneti ime!",
                  },
                ]
          }
        >
          {props.compoanyRegistration ? (
            <AutoComplete
              allowClear={true}
              options={props.importedParticipantOptions}
              className="input-label"
              onSelect={(value) => onNameSelect(value)}
              placeholder="Unesite ime"
              filterOption={(inputValue, option: any) =>
                option!.value
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              }
            />
          ) : (
            <Input
              className="input-label"
              placeholder="Unesite ime"
              addonAfter={<EditOutlined />}
            />
          )}
        </Form.Item>
        <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "lastName"]}
          label="Prezime:"
          rules={
            props.individual && props.name === 0
              ? []
              : [
                  {
                    required: true,
                    message: "Potrebno je uneti prezime!",
                  },
                ]
          }
        >
          <Input className="input-label" placeholder="Unesite prezime" />
        </Form.Item>
        <div className="phone-input-container">
          <Form.Item
            {...props.restField}
            className="form-box"
            name={[props.name, "phone"]}
            label="Kontakt telefon:"
            rules={
              props.individual && props.name === 0
                ? []
                : [
                    {
                      required: true,
                      message: "",
                    },
                    {
                      validateTrigger: "onChange",
                      validator: async (_, value) => {
                        if (value === undefined || value === null) {
                          return setPhoneError(true);
                        } else {
                          if (!phoneRegex.test(value)) {
                            setPhoneError(true);
                            return Promise.reject();
                          } else {
                            setPhoneError(false);
                            return Promise.resolve();
                          }
                        }
                      },
                    },
                  ]
            }
          >
            <PhoneInput
              className={phoneError ? "phone-input-error" : "phone-input"}
              onChange={() => {}}
              placeholder="Unesite broj telefona"
            />
          </Form.Item>
          <p
            className={
              !phoneError ? "phone-description" : "phone-description-no-visible"
            }
          >
            Unesite ispravan format +381 66 12345678
          </p>
        </div>
        <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "email"]}
          label="E-mail:"
          rules={
            props.individual && props.name === 0
              ? []
              : [
                  {
                    required: true,
                    message: "Potrebno je uneti e-mail adresu!",
                  },
                  {
                    validateTrigger: "submit",
                    type: "email",
                    message: "Unesite ispravan format e-maila!",
                  },
                ]
          }
        >
          <Input
            className="input-label"
            placeholder="Unesite e-mail adresu"
            addonAfter={<EditOutlined />}
          />
        </Form.Item>
        <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "country"]}
          label="Zemlja:"
          rules={
            props.individual && props.name === 0
              ? []
              : [
                  {
                    required: true,
                    message: "Izaberite Zemlju!",
                  },
                ]
          }
        >
          <Select
            onChange={handleCountryChange}
            placeholder="Izaberite Zemlju"
            options={Country}
          />
        </Form.Item>

        {/* {!props.isAccommodationRequired &&
          props.isAccommodationRequired !== undefined && (
            <span className="new-checkbox-fee">
              <Form.Item
                valuePropName="checked"
                {...props.restField}
                className="form-box"
                name={[props.name, "dinner"]}
              >
                <Checkbox
                  onChange={(e: any) => {
                    handleDinnerCalculation(e);
                  }}
                  className="checkbox"
                >
                  <p className="checkbox-text">Svecana vecera</p>
                </Checkbox>
              </Form.Item>

              <Form.Item
                valuePropName="checked"
                {...props.restField}
                className="form-box"
                name={[props.name, "registrationFee"]}
              >
                <Checkbox
                  onChange={(e: any) => {
                    handleRegistrationFeeCalculation(e);
                  }}
                  className="checkbox"
                >
                  <p className="checkbox-text">Kotizacija</p>
                </Checkbox>
              </Form.Item>
            </span>
          )} */}

        {/* <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "city"]}
          label="Grad:"
        >
          <Input className="input-label" placeholder="Unesite grad" />
        </Form.Item>
        <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "street"]}
          label="Ulica:"
        >
          <Input className="input-label" placeholder="Unesite ulicu" />
        </Form.Item>
        <Form.Item
          {...props.restField}
          className="form-box"
          name={[props.name, "streetNumber"]}
          label="Broj:"
        >
          <Input className="input-label" placeholder="Unesite broj" />
        </Form.Item> */}
        {/* {country === "Srbija" ? (
          <>
            <Form.Item
              {...props.restField}
              className="form-box"
              name={[props.name, "nationalId"]}
              label="Broj lične karte:"
              rules={
                props.individual && props.name === 0
                  ? []
                  : [
                      // {
                      //   required: true,
                      //   message: "Potrebno je uneti broj lične karte!",
                      // },
                    ]
              }
            >
              <Input
                placeholder="Unesite broj lične karte"
                type="number"
                className="input-label"
                addonAfter={<EditOutlined />}
              />
            </Form.Item>
            <Form.Item
              {...props.restField}
              className="form-box"
              name={[props.name, "personalId"]}
              label="JMBG:"
              rules={
                props.individual && props.name === 0
                  ? []
                  : [
                      // {
                      //   required: true,
                      //   message: "Potrebno je uneti broj lične karte!",
                      // },
                      {
                        validateTrigger: "submit",
                        validator: async (_, value) => {
                          if (value === undefined || value === null) return;
                          if (!validatePersonalId(value)) {
                            return Promise.reject(
                              new Error("Unesite ispravan JMBG")
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ]
              }
            >
              <Input
                placeholder="Unesite JMBG"
                type="number"
                className="input-label"
                addonAfter={<EditOutlined />}
              />
            </Form.Item>
          </>
        ) : (
          <Form.Item
            {...props.restField}
            className="form-box"
            name={[props.name, "nationalId"]}
            label="Broj pasoša:"
            rules={
              props.individual && props.name === 0
                ? []
                : [
                    // {
                    //   required: true,
                    //   message: "Potrebno je uneti broj pasoša!",
                    // },
                  ]
            }
          >
            <Input type="number" className="input-label" />
          </Form.Item>
        )} */}
        <div
          className={
            country === "Srbija" ? "field-container-small" : "field-container"
          }
        >
          <div
            className="btn"
            onClick={() =>
              props.accommodation ? handleResetFields() : handleDeleteRow()
            }
          >
            <img alt="" src={props.accommodation ? Refresh : Bin} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewParticipant;
